import { call, put } from "redux-saga/effects";
import { userApi } from "@services/api";
import { getProfileActions } from "../slices";

function* getProfileWorker() {
  try {
    yield put(getProfileActions.pending());
    const response = yield call(userApi.getProfile);
    yield put(getProfileActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getProfileActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { getProfileWorker };
